import React, { useState } from "react";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Checkbox } from "@mui/material"; // Ensure MUI is available or use standard input
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";

const LeaveEncashmentTable = ({ data, onViewDetail }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const headers = ["Employee ID", "Full Name", "Classification", "Total Balance", "Encashable", "Total Value", "Actions"];
  const accessors = ["employeeId", "fullName", "classificationDescription", "totalLeaveBalance", "totalEncashable", "totalGross", "actions"];

  const actions = [
    {
      tooltip: "View Details",
      icon: <VisibilityIcon fontSize="small" />,
      color: "bg-blue-600",
      visible: true,
      function: (row) => onViewDetail(row),
    }
  ];

  const customCellRenderer = (row, accessor) => {
    if (accessor === "totalGross") return <span className="text-blue-800 font-extrabold">₱{row[accessor].toLocaleString()}</span>;
    if (accessor === "totalEncashable") return <span className="font-bold">{row[accessor]} Days</span>;
    return null;
  };

  return (
    <CreateTable
      tableName="LeaveSummaryTable"
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data.length}
      customCellRenderer={customCellRenderer}
    />
  );
};

export default LeaveEncashmentTable;